import classNames from 'classnames';
import styles from './faqLayout.module.scss';

const FaqLayout = ({ sidebar, mobileNav, mobileNavPosition = 'top', children, className }) => (
  <div className={classNames(styles.layout, className)}>
    {sidebar && <aside className={styles.aside}>{sidebar}</aside>}
    <main className={styles.main}>
      {mobileNav && mobileNavPosition === 'top' && (
        <div className={styles.mobileNav}>{mobileNav}</div>
      )}
      {children}
      {mobileNav && mobileNavPosition === 'bottom' && (
        <div className={classNames(styles.mobileNav, styles.mobileNavBottom)}>{mobileNav}</div>
      )}
    </main>
  </div>
);

export default FaqLayout;
